import Reflux from 'reflux'
import axios from 'axios'
import _ from 'lodash'

import QuantitiesActions from '~/actions/quantities.js'

import apiUtils from '../helper/api.js'


export default class extends Reflux.Store {
	constructor() {
		super()

		this.listenables = QuantitiesActions

		this.state = {
			quantities: [],
			quantityFilterLetter: '',
			showQuantityModal: false
		}

		// hydrate as soon as initialized
		this.reload()
	}

	reload() {
		axios.get(`${apiUtils.getApiURL()}/quantities?filter[where][isActive]=1`)
			.then(
				(response) => {
					let quantities = response.data

					quantities = _.forEach(
						quantities,
						(theQuantity) => {
							const newQuantity = theQuantity

							newQuantity.capitalized = theQuantity.quantity.toUpperCase()
							newQuantity.firstLetter = newQuantity.capitalized.substring(0, 1)

							return newQuantity
						}
					)

					this.setState({ quantities: _.sortBy(quantities, 'capitalized') })
				}
			)
	}

	setFilterLetter(quantityFilterLetter) {
		this.setState({ quantityFilterLetter })
	}

	showModal() {
		this.setState({ showQuantityModal: true })
	}

	hideModal() {
		this.setState({ showQuantityModal: false })
	}
}



// WEBPACK FOOTER //
// ./src/stores/quantities.js